<form [formGroup]="formGroup">
    <table mat-table [dataSource]="tableData" class="table table-sm table-bordered">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef style="width: 300px">{{ rowName }}</th>
            <td mat-cell *matCellDef="let element">{{ rowName }}</td>
        </ng-container>

        <ng-container matColumnDef="currentLocale">
            <th mat-header-cell *matHeaderCellDef>{{ currentLocale }}</th>
            <td mat-cell *matCellDef="let element">
                <div [formGroup]="formGroup">
                    <textarea
                        matInput
                        placeholder="keep all the html tags like <p>..."
                        [formControl]="formGroup.get('currentLocale')"
                    ></textarea>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="selectedLocale">
            <th mat-header-cell *matHeaderCellDef>{{ selectedLocale }}</th>
            <td mat-cell *matCellDef="let element">
                <div [formGroup]="formGroup">
                    <textarea
                        matInput
                        placeholder="keep all the html tags like <p>..."
                        [formControl]="formGroup.get('selectedLocale')"
                    ></textarea>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</form>
